import { isLuxLoyaltyEnabledInAgentHub } from 'agentHub/selectors/agentHubSelectors'
import getHasLoyaltyAccount from 'loyalty/selectors/getHasLoyaltyAccount'

function getShouldEarnLoyaltyPoints(state: App.State): boolean {
  const hasLoyaltyAccount = getHasLoyaltyAccount(state)
  const enrolAtCheckout = state.checkout.loyalty.enrolCustomerAtCheckout

  // for agent hub, we want to earn loyalty points for all bookings even if user does not have a loyalty account
  // this is due to agents not earning points, but their customers will (when typing in the société member number)
  if (isLuxLoyaltyEnabledInAgentHub) {
    return true
  }

  return hasLoyaltyAccount || enrolAtCheckout
}

export default getShouldEarnLoyaltyPoints
